/** IVA México — precios de catálogo son sin impuesto */
export const IVA_TASA = 0.16;

export function calcularIva(subtotal: number): number {
  return Math.round(subtotal * IVA_TASA * 100) / 100;
}

export function totalConIva(subtotal: number): number {
  return Math.round((subtotal + calcularIva(subtotal)) * 100) / 100;
}
